// src/store/reducers/notificationReducer.js
import { SHOW_NOTIFICATION, CLEAR_NOTIFICATION, SHOW_REMANING_NOTIFICATION } from 'Store/actions/notificationActions';

const initialState = {
  notifications: [],  // Array to store notifications
  unreadCount: 0,     // Count of unread notifications
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      const newNotifications = [action.payload, ...state.notifications]; 
      return {
        ...state,
        notifications: newNotifications,
        unreadCount: newNotifications.filter(n => !n.read).length,
      };
    case SHOW_REMANING_NOTIFICATION: {
      if (action.payload?.id && state.notifications.some(n => n.id === action.payload.id)) {
        return state;
      }
      const newRemaningNotifications = [action.payload, ...state.notifications];
      return {
        ...state,
        notifications: newRemaningNotifications,
        unreadCount: newRemaningNotifications.filter(n => !n.read).length,
      };
    }
    case CLEAR_NOTIFICATION:
      return {
        ...state,
        notifications: [],
        unreadCount: 0,  // Reset count when clearing notifications
      };
    case 'MARK_AS_READ': {
      // Mark the specific notification as read
      const updatedNotifications = state.notifications.map(notification =>
        notification.id === action.payload.id ? { ...notification, read: true } : notification
      );

      // Calculate the updated unread count
      const unreadCount = updatedNotifications.filter(n => !n.read).length;
      return {
        ...state,
        notifications: updatedNotifications,
        unreadCount, // Set the updated unread count
      };
    }
    default:
      return state;
  }
};

export default notificationReducer;
